module.exports = __webpack_public_path__ + "img/2.a1eac655.png";